var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login_result_page",style:({ backgroundImage: 'url(' + _vm.bgPath + ')' })},[_c('el-button',{staticClass:"start_btn",attrs:{"type":"primary"},on:{"click":_vm.startUse}},[_vm._v("开始使用")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }